import { IFormCoreInputProps } from "../types";

export const FormCoreInput = (props: IFormCoreInputProps) => {
  return (
    <input
      className="bg-transparent outline-none text-md text-gray-v2-900 disabled:text-gray-v2 placeholder:text-gray-v2-500 w-full"
      placeholder={props.placeholder}
      value={props.value}
      disabled={props.disabled}
      onChange={props.onChange}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
    />
  );
};
